/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import paginationFactory, {PaginationListStandalone, PaginationProvider} from "react-bootstrap-table2-paginator"

import BootstrapTable from "react-bootstrap-table-next"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Container,
    CardText,
    Badge,
} from "reactstrap"
import * as moment from "moment";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
export const SpribeModalTable = props => {
    const { columns, data } = props

    // Table Data
    const pageOptions = {
        sizePerPage: 5,
        totalSize: data?.length??0,
        custom: true,
    }
    return (
        <Fragment>
            <Card>
                <CardBody>
                    {

                            <PaginationProvider
                                pagination={paginationFactory(pageOptions)}
                                keyField="id"
                                columns={columns}
                                data={data}
                            >
                                {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                        keyField="id"
                                        data={data}
                                        columns={columns}
                                        bootstrap4

                                    >
                                        {toolkitProps => (
                                            <React.Fragment>
                                                <Row>
                                                    <Col xl="12">
                                                        <div className="table-responsive">
                                                            <BootstrapTable
                                                                keyField="id"
                                                                responsive
                                                                bordered={false}
                                                                striped={false}

                                                                classes={
                                                                    "table align-middle table-nowrap table-check"
                                                                }

                                                                {...toolkitProps.baseProps}
                                                                {...paginationTableProps}

                                                                hover
                                                                rowClasses={"mytable-hover-row"}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className="pagination pagination-rounded justify-content-end">
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </ToolkitProvider>
                                )}
                            </PaginationProvider>

                    }


                </CardBody>
            </Card>
        </Fragment>
    )
}
